import React from 'react';
import PropTypes from 'prop-types';

const HeaderDr = ({
  discipline,
  schoolYear,
  dreAndMunicipio,
  periodoAno,
  dreOrDr = 'REDE',
  disciplineLabel = 'Componente Curricular/Área do Conhecimento'
}) => {
  return (
    <>
      <div
        className="container__background"
        style={{ gridTemplateColumns: "none", gridAutoFlow: "column" }}
      >
        {discipline && (
          <div className="input__background">
            <span className="first__info">
              {disciplineLabel}: <span>{discipline}</span>
            </span>
          </div>
        )}
        {schoolYear && (
          <div className="input__background">
            <span className="first__info">
              Série/Ano Escolar: <span>{schoolYear}</span>
            </span>
          </div>
        )}
        {dreAndMunicipio && (
          <div className="input__background">
            <span className="first__info">
              {dreOrDr}: <span>{dreAndMunicipio}</span>
            </span>
          </div>
        )}
        {periodoAno && (
          <div className="input__background">
            <span className="first__info">
              Prova: <span>{periodoAno}</span>
            </span>
          </div>
        )}
      </div>
    </>
  );
};

HeaderDr.propTypes = {
  discipline: PropTypes.string,
  schoolYear: PropTypes.string,
  dreAndMunicipio: PropTypes.string,
  periodoAno: PropTypes.string,
  disciplineLabel: PropTypes.string
};

export default HeaderDr;
